/*
 * Newsletter do rodapé com cupom (bloco "contato" do tp-footer).
 * O botão abre o campo de e-mail. O envio é o normal do formulário de cliente
 * da Shopify (tag newsletter), que passa pelo captcha da loja; ao voltar com
 * customer_posted=true, o Liquid mostra o cupom (form.posted_successfully?).
 */
if (!customElements.get('tp-footer-newsletter')) {
  customElements.define(
    'tp-footer-newsletter',
    class TpFooterNewsletter extends HTMLElement {
      connectedCallback() {
        this.openButton = this.querySelector('[data-nl-open]');
        this.fields = this.querySelector('[data-nl-fields]');
        this.input = this.querySelector('input[type="email"]');

        this.openButton?.addEventListener('click', () => this.open());
        this.bindCopy();

        // Volta do cadastro: o feed do Instagram carrega depois e empurra o rodapé
        const success = this.querySelector('[data-nl-success]:not([hidden])');
        if (success) {
          window.addEventListener('load', () => setTimeout(() => success.scrollIntoView({ block: 'center' }), 300), { once: true });
        }
      }

      open() {
        this.openButton.hidden = true;
        this.openButton.setAttribute('aria-expanded', 'true');
        this.fields.hidden = false;
        this.input.focus();
      }

      bindCopy() {
        const copyButton = this.querySelector('[data-nl-copy]');
        const code = this.querySelector('[data-nl-code]');
        if (!copyButton || !code) return;
        copyButton.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(code.textContent.trim());
            copyButton.textContent = 'Copiado!';
          } catch (error) {
            const range = document.createRange();
            range.selectNodeContents(code);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
          }
        });
      }
    }
  );
}
